import React, { useState, useEffect } from "react";
// import axios from "axios";
import "./AuthorShowReview.css"; // Updated the CSS file name to match the component

const AuthorShowReview = () => {
  const [reviewData, setReviewData] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const [errorMessage, setErrorMessage] = useState(""); // Add state for error message

  useEffect(() => {
    // Simulate loading and then show static message
    setTimeout(() => {
      setLoading(false);
      setErrorMessage("No reviews are available at this time. Reviews will appear here once reviewers have evaluated your submitted papers.");
    }, 1000);

    // Commented out API call - showing static message instead
    // const storedEmail = localStorage.getItem("email");
    // const storedRole = localStorage.getItem("role");

    // if (storedEmail && storedRole) {
    //   // Fetch papers with both email and role using axios
    //   axios
    //     .get(
    //       `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/submit/get-reviews-info`,
    //       {
    //         params: {
    //           email: storedEmail,
    //           role: storedRole,
    //         },
    //       }
    //     )
    //     .then((response) => {
    //       // console.log("Response from backend:", response.data); // Log the response to check if Paper-1 is included

    //       const data = response.data;

    //       // If no data is returned, set the appropriate error message
    //       if (data?.data?.length === 0) {
    //         setErrorMessage("No Reviewers reviewed your paper yet.");
    //       } else {
    //         setReviewData(data?.data || []); // Set the review data if found
    //         setErrorMessage(""); // Clear any previous error message
    //       }

    //       setLoading(false); // Set loading to false after data is fetched
    //     })
    //     .catch((error) => {
    //       // console.error('Error fetching data:', error);
    //       setErrorMessage("Error loading reviews."); // Set error message on failure
    //       setLoading(false); // Set loading to false if there is an error
    //     });
    // } else {
    //   setErrorMessage("No email or role found."); // Set error message if no email and role
    //   setLoading(false); // Set loading to false if no email and role are found
    // }
  }, []);

  // Update to use "reviewers" instead of "assignedReviewer"
  const filteredReviewData = reviewData.filter(
    (paper) =>
      (paper.status === "Accepted" || paper.status === "Rejected") &&
      Array.isArray(paper.reviewers) && // Check if reviewers exist
      paper.reviewers.some(
        (reviewer) =>
          reviewer.reviewMessage ||
          reviewer.recommendation ||
          reviewer.reviewPicURL
      )
  );

  // console.log("Filtered review data:", filteredReviewData); // Log the filtered review data to check if Paper-1 is included

  return (
    <div className="authorShow-review-container">
      <div className="authorShow-review-header">
        <h1 className="authorShow-review-title">Paper Reviews</h1>
        <p className="authorShow-review-subtitle">Detailed feedback from reviewers</p>
      </div>

      {loading ? (
        <div className="authorShow-loading-state">
          <div className="authorShow-spinner"></div>
          Loading reviews...
        </div>
      ) : (
        <>
          {errorMessage ? (
            <div className="authorShow-no-reviews-state">
              <div className="authorShow-no-reviews-icon">
                <svg width="64" height="64" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3>No Reviews Available</h3>
              <p>{errorMessage}</p>
              <div className="authorShow-help-text">
                <p>Reviews will appear here once:</p>
                <ul>
                  <li>Your paper has been submitted successfully</li>
                  <li>Reviewers have been assigned to evaluate your work</li>
                  <li>The review process has been completed</li>
                </ul>
              </div>
            </div>
          ) : (
            <>
              {filteredReviewData.length > 0 ? (
                filteredReviewData.map((paper, paperIndex) => (
                  <div className="authorShow-review-card" key={paperIndex}>
                    <div className="authorShow-paper-header">
                      <h3>{paper.title}</h3>
                      <span className={`status-badge ${paper.status.toLowerCase()}`}>
                        {paper.status}
                      </span>
                    </div>
                    
                    <div className="authorShow-table-container">
                      <table className="authorShow-review-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Reviewer</th>
                            <th>Feedback</th>
                            <th>Recommendation</th>
                            <th>Attachment</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paper.reviewers.map((review, index) => (
                            review.reviewMessage || review.recommendation || review.reviewPicURL ? (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{review.name}</td>
                                <td>{review.reviewMessage || '-'}</td>
                                <td>{review.recommendation || '-'}</td>
                                <td>
                                  {review.reviewPicURL && (
                                    <a href={review.reviewPicURL} 
                                       target="_blank" 
                                       rel="noopener noreferrer"
                                       className="authorShow-review-link">
                                      View Document
                                    </a>
                                  )}
                                </td>
                              </tr>
                            ) : null
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))
              ) : (
                <div className="authorShow-no-data">No review data available</div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default AuthorShowReview;
